var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import Box from "../Box";
import DropDown from "../DropDown";
import { messages } from "../../messages";
var CategoryFilterView = /** @class */ (function (_super) {
    __extends(CategoryFilterView, _super);
    function CategoryFilterView(props) {
        var _this = _super.call(this, props) || this;
        _this.toggle = _this.toggle.bind(_this);
        _this.state = {
            dropdownOpen: false
        };
        return _this;
    }
    CategoryFilterView.prototype.reset = function () {
        this.onCategorySelected(undefined);
    };
    CategoryFilterView.prototype.onGenreSelected = function (value) {
        this.props.onGenreChange(value);
    };
    CategoryFilterView.prototype.onCategorySelected = function (value) {
        this.props.onCategoryChange(value);
    };
    CategoryFilterView.prototype.toggle = function () {
        this.setState(function (prevState) { return ({
            dropdownOpen: !prevState.dropdownOpen
        }); });
    };
    CategoryFilterView.prototype.renderContent = function () {
        return React.createElement(React.Fragment, null,
            React.createElement("h3", null, messages.ChooseCategory),
            React.createElement(DropDown, { style: { marginTop: '20px' }, selectText: messages.SelectACategory, dataSource: this.props.categories, keyExtractor: function (t) { return t.id.toString(); }, valueExtractor: function (t) { return t.name; }, onValueSelected: this.props.onCategoryChange, selected: this.props.category }),
            React.createElement(DropDown, { style: { marginTop: '20px' }, selectText: messages.SelectGenre, dataSource: this.props.genres, keyExtractor: function (t) { return t.id.toString(); }, valueExtractor: function (t) { return t.name; }, onValueSelected: this.props.onGenreChange, selected: this.props.genre }));
    };
    CategoryFilterView.prototype.render = function () {
        if (this.props.noBox) {
            return React.createElement("div", { className: 'category-filter', style: this.props.style }, this.renderContent());
        }
        return (React.createElement(Box, { className: 'category-filter', style: this.props.style }, this.renderContent()));
    };
    return CategoryFilterView;
}(React.PureComponent));
export default CategoryFilterView;
//# sourceMappingURL=CategoryFilter.js.map


//////////////////
// WEBPACK FOOTER
// ./bpm-web-generic/lib/components/filter/CategoryFilter.js
// module id = 476
// module chunks = 0